import { render } from "./AppDesktop.vue?vue&type=template&id=6e0d4e5e&scoped=true"
import script from "./AppDesktop.vue?vue&type=script&lang=js"
export * from "./AppDesktop.vue?vue&type=script&lang=js"

import "./AppDesktop.vue?vue&type=style&index=0&id=6e0d4e5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e0d4e5e"

export default script